import { OverwriteScope } from "hoxton-shared/enums/overwrites";

const EditableGroupScopeLabel = "";
const ExportGroupScopeLabel = "All Sizes";

const TemplateOverwriteScopes = [OverwriteScope.Template, OverwriteScope.EditableGroupTemplate];

const OverwriteScopeOrder = {
    [OverwriteScope.Campaign]: 1,
    [OverwriteScope.Template]: 2,
    [OverwriteScope.EditableGroup]: 3,
    [OverwriteScope.EditableGroupTemplate]: 4
} as const;

export { ExportGroupScopeLabel, EditableGroupScopeLabel, OverwriteScope, OverwriteScopeOrder, TemplateOverwriteScopes };
